import { useTranslation } from 'react-i18next';
import { Mic } from 'lucide-react';

interface VoiceAiBadgeProps {
  confidence?: number;
}

export default function VoiceAiBadge({ confidence }: VoiceAiBadgeProps) {
  const { t } = useTranslation();
  const pct = confidence != null ? Math.round(confidence * 100) : null;

  let colorClass = 'bg-surface-100 text-surface-600';
  let dotColor = 'bg-surface-400';
  if (pct != null) {
    if (pct > 80) {
      colorClass = 'bg-success-100 text-success-700';
      dotColor = 'bg-success-500';
    } else if (pct >= 60) {
      colorClass = 'bg-warning-100 text-warning-700';
      dotColor = 'bg-warning-500';
    } else {
      colorClass = 'bg-danger-100 text-danger-700';
      dotColor = 'bg-danger-500';
    }
  }

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${colorClass}`}>
      <Mic size={12} />
      <span>{t('voiceBadge.label')}</span>
      {pct != null && (
        <>
          <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
          <span>{pct}%</span>
        </>
      )}
    </span>
  );
}
